export default {
  apiSettings: {
    title: 'API设置',
    tabs: {
      prod: '生产环境',
      test: '测试环境'
    },
    security: {
      title: '安全设置',
      accessKey: 'Access Key (AK)',
      secretKey: 'Secret Key (SK)',
      view: '查看',
      hide: '隐藏',
      reset: '重置'
    },
    callback: {
      title: '回调地址设置',
      prodUrl: '正式回调地址：',
      prodDesc: '用于生产环境的回调地址',
      testUrl: '测试回调地址：',
      testDesc: '用于测试环境的回调地址',
      save: '保存回调地址'
    },
    ip: {
      title: 'IP设置',
      whitelist: '白名单IP地址（一行一个）：',
      whitelistExtra: '请输入需要加入白名单的IP地址，每行一个IP地址',
      placeholder: '192.168.1.1\n10.0.0.1\n172.16.0.1',
      saveProd: '保存生产环境IP设置',
      saveTest: '保存测试环境IP设置'
    },
    reset: {
      title: '重置AK/SK',
      warning: '重置后将生成新的AK/SK，原有的AK/SK将失效。请选择接收验证码的方式：',
      phone: '手机号接收',
      email: '邮箱接收',
      phonePlaceholder: '手机号',
      emailPlaceholder: '邮箱',
      verificationCode: '请输入验证码',
      sendCode: '发送验证码',
      cancel: '取消',
      confirm: '确认重置'
    },
    resetSuccess: {
      title: '重置成功',
      successTitle: '重置成功！新SK 为：',
      warning: '请妥善保管，绝不可泄露！',
      ok: '我知道了'
    },
    messages: {
      codeSent: '验证码已发送到您的{target}',
      codeSendFailed: '发送验证码失败',
      codeRequired: '请输入验证码',
      resetFailed: '重置失败',
      noConfig: '暂无API配置，无法操作',
      callbackSaveSuccess: '回调地址保存成功',
      callbackSaveFailed: '保存失败',
      ipSaveSuccess: 'IP设置保存成功',
      ipSaveFailed: '保存失败',
      loadFailed: '获取配置信息失败'
    }
  }
}
